import uberDirectStructAddress from './structAddress';
import UberDirectStatus from './uberDirectStatus';

const UberDirect = { uberDirectStructAddress, UberDirectStatus };

export default UberDirect;
